var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "q-field",
        {
          staticClass: "q-field-force-input",
          attrs: {
            label: !_vm.hideLabel ? _vm.$t("phone") : "",
            labelWidth: 2,
            icon: _vm.showIcon ? "phone" : undefined
          }
        },
        [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { class: _vm.columnWidth },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "no-margin",
                    attrs: {
                      error: _vm.errors.has("phone_" + _vm.id),
                      "error-label": _vm.errors.first("phone_" + _vm.id)
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: { max: 255, regex: /^[ 0-9A-z.,\+\-()/*#]*$/ },
                          expression:
                            "{ max: 255, regex:/^[ 0-9A-z.,\\+\\-()/*#]*$/ }",
                          modifiers: { disable: true }
                        }
                      ],
                      attrs: {
                        type: "tel",
                        name: "phone_" + _vm.id,
                        "data-vv-as": _vm.$t("phone"),
                        placeholder: _vm.$t("phone")
                      },
                      model: {
                        value: _vm.phone.number,
                        callback: function($$v) {
                          _vm.$set(_vm.phone, "number", $$v)
                        },
                        expression: "phone.number"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isEmpty && _vm.label,
                    expression: "!isEmpty && label"
                  }
                ],
                class: _vm.columnWidth
              },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "no-margin",
                    attrs: {
                      error: _vm.errors.has("phoneLabel_" + _vm.id),
                      "error-label": _vm.errors.first("phoneLabel_" + _vm.id)
                    }
                  },
                  [
                    _c("label-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "max:255",
                          expression: "'max:255'",
                          modifiers: { disable: true }
                        }
                      ],
                      attrs: {
                        name: "phoneLabel_" + _vm.id,
                        labelList: "phone"
                      },
                      model: {
                        value: _vm.phone.label,
                        callback: function($$v) {
                          _vm.$set(_vm.phone, "label", $$v)
                        },
                        expression: "phone.label"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }